module.exports = __webpack_public_path__ + "img/game_BG.f9b16a51.jpg";